//-- Copyright (c) 2021 TMT Insights Group, LLC
import { Link } from 'react-router-dom';
import { Button, Grid } from '@mui/material';

import { DataTableConfig } from '@/__configs/config_types';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { clearFilters } from '@/redux/slices/dataTableSlice';
import { selectCanWriteOrders } from '@/redux/selectors/authSelectors';
import { dataTableInitialState } from '@/redux/selectors/configSelectors';
import { selectCurrentTableKey, selectDataTableAppliedSearchName } from '@/redux/selectors/dataTableSelectors';
import { Breadcrumbs, Title, TitleBar } from '@/components/_common';
import PolarisIcon from '@/components/_common/PolarisIcon';

const JobsTitleBar = () => {
  const dispatch = useAppDispatch();
  const appliedSearchName = useAppSelector(selectDataTableAppliedSearchName);
  const tableName = useAppSelector(selectCurrentTableKey);
  const title = dataTableInitialState[tableName as keyof DataTableConfig]?.title;
  const canWriteOrders = useAppSelector(selectCanWriteOrders);

  const onBreadcrumbClick = () => {
    dispatch(clearFilters(undefined));
  };

  return (
    <TitleBar>
      <Grid container justifyContent="space-between" alignItems="center">
        {!appliedSearchName ? (
          <Title>{title || 'Jobs'}</Title>
        ) : (
          <Breadcrumbs aria-label="breadcrumb">
            <Link to="/jobs" onClick={onBreadcrumbClick}>
              {title || 'Jobs'}
            </Link>
            <span>&ldquo;{appliedSearchName}&ldquo;</span>
          </Breadcrumbs>
        )}

        {canWriteOrders && (
          <Button variant="contained" color="primary" component={Link} to="orders-v2/new" startIcon={<PolarisIcon icon="add" height={16} />}>
            New Order
          </Button>
        )}
      </Grid>
    </TitleBar>
  );
};

export default JobsTitleBar;
